import { render, staticRenderFns } from "./BsDropdown.vue?vue&type=template&id=4901d8ac&scoped=true&"
import script from "./BsDropdown.vue?vue&type=script&lang=js&"
export * from "./BsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4901d8ac",
  null
  
)

export default component.exports